
import Vue from "vue";
import Component from "vue-class-component";
import FormLayout from "@/features/personProfile/components/FormLayout.vue";

import {
    AddSeafaringPracticeRequest, ApiException,
    factory, IAddSeafaringPracticeRequest,
    PracticesClient, QualificationsClient,
    SeafaringPracticeActions, SeafaringPracticeDetailsModel
} from "@/api-client";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import SeafaringPracticeUpsertForm from "@/features/documents/practices/components/SeafaringPracticeUpsertForm.vue";
import {Location} from "vue-router";

interface Props {
    seafarerId: string;
    actions: SeafaringPracticeActions;
    existingPractice: SeafaringPracticeDetailsModel;
}

@Component({
    components: {
        FormLayout,
        SeafaringPracticeUpsertForm
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditSeafaringPractice>) {
        const props = to.meta!.props as Props;
        props.seafarerId = to.params.seafarerId;
        const practiceId = to.params.id;
        Promise.all([
            new PracticesClient().availableSeafaringActions(),
            new PracticesClient().getSeafaring(practiceId),
        ]).then(values => {
            props.actions = values[0];
            props.existingPractice = values[1];
            next();
        }).catch(e => next(e))
    }
})
export default class EditSeafaringPractice extends Vue implements Props {
    @Prop({required: true})
    seafarerId!: string;

    @Prop({required: true})
    actions!: SeafaringPracticeActions;

    @Prop({required: true})
    existingPractice!: SeafaringPracticeDetailsModel;

    @Prop({default: null})
    returnRoute!: Location | null;

    model: AddSeafaringPracticeRequest = factory.create(AddSeafaringPracticeRequest);

    isCreated = false;

    async created() {
        this.model = new AddSeafaringPracticeRequest({
            ...this.existingPractice,
            existingFiles: this.existingPractice.files,
            addedFiles: [],
            removedFiles: []
        } as IAddSeafaringPracticeRequest)
        this.isCreated = true;
    }

    async submit(model: AddSeafaringPracticeRequest) {
        await new PracticesClient()
            .edit(model, this.seafarerId, this.existingPractice.id);

        const route = (this.returnRoute ? this.returnRoute : { name: "seafaring-practice-details" }) as Location;
        route.params = {id: this.existingPractice.id, seafarerId: this.seafarerId};
        this.$router.replace(route);
    }
}
